/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import {
  Container,
  TextField,
  Autocomplete,
  FormControl,
  useTheme,
  Stack,
  Grid,
  Snackbar,
  Alert,
  Slide,
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  IconButton,
  Checkbox,
  TableCell,
} from '@mui/material';
import tableCellClasses from '@mui/material/TableCell';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import { Link, useNavigate, useParams } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import imagepreview from '../../media/time.png';
import noImage from '../../media/noimage.jpg';
import '../stylemod.css';
import axios from '../../axiosConfig';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  // backgroundColor: theme.palette.info.main,
  backgroundColor: '#A7D397',
  color: theme.palette.common.white,
  border: '1px solid white',
}));

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

export default function AddStyleRateCard() {
  const { id, id1 } = useParams();
  const { type } = useParams();
  const theme = useTheme();
  console.log(id, 'type is', type);
  const classes = useStyles();
  const navigate = useNavigate();
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  // OPERATIONAL REQUIREMNETS STATES
  const [currentDate, setCurrentDate] = React.useState(new Date());
  const [headerData, setHeaderData] = useState([]);
  const [buyerSelected, setbuyerSelected] = React.useState('');
  const [BuyerData, setBuyerData] = useState([]);
  const [garmentsData, setGarmentsData] = useState([]);
  const [garmentSelected, setGarmentSelected] = React.useState('');
  const [styleDesc, setStyleDesc] = React.useState('');
  const [styleNum, setStyleNum] = React.useState('');
  const [remarks, setRemarks] = React.useState('');
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = React.useState('');
  const [lineData, setLineData] = useState([]);
  const [lineSelected, setLineSelected] = React.useState('');
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [finalOperation, setFinalOperation] = React.useState('');

  // ADD OPRATIONS STATES
  const [opGroupSelected, setOpGroupSelected] = useState({ op_group_name: 'All Groups' });
  const [selectedOperations, setSelectedOperations] = useState([]);
  const [OperationData, setOperationData] = useState([]);
  const [opGroupData, setOpGroupData] = useState([]);
  const [operationDetails, setOperationDetails] = useState([]);

  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [openDelete, setOpenDelete] = useState(false);
  // others
  const [alertType, setAlertType] = useState('success');
  const [openAlert, setopenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [machineData, setMachineData] = useState([]);

  const [fieldErrors, setFieldErrors] = React.useState({
    // opertional requirements
    buyerSelected: false,
    garmentSelected: false,
    styleDesc: false,
    styleNum: false,
    // lineSelected: false,
    unitSelected: false,
    remarks: false,
    finalOperation: false
  });

  const resetFields = () => {
    setbuyerSelected(null);
    setGarmentSelected(null);
    setStyleDesc('');
    setStyleNum('');
    setRemarks('');
    setUnitSelected('');
    setLineSelected('');
    setFinalOperation('');
  };

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and error state based on the fileType
    if (fileType === 'photo') {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, selectedImageFile: false }));
    }
  };

  // API Integration
  React.useEffect(() => {
    console.log(id, 'type is', type);
    GetAllOperationMstData();
    GetAllMachineMstData();
    GetAllActiveBuyers();
    GetAllActiveGarmentMst();
    GetAllActiveOperationGrpData();
    GetAllActiveProductionUnits();
  }, []);

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => { }, [searchTerm]);

  const filteredData = OperationData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // get all Buyers Request
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setBuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllActiveGarmentMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveGarmentMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGarmentsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all group Request
  const GetAllActiveOperationGrpData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationGrpData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOpGroupData(res.data);

      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all machine data
  const GetAllMachineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  // pre fill data for editing screen
  useEffect(() => {
    const GetoneObHeader = async (id) => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`GetoneStyleRateHearder/${id}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        const data = res.data;
        setHeaderData(res.data[0]);
        data.forEach((editDataonID) => {
          const { Buyerid, GarmentDescription, StyleDescription, StyleNumber, Batchid, Unit_Id, remarks, SrhImage } =
            editDataonID;
          const selectedBuyer = BuyerData.find((obj) => obj.Buyer_Id === Buyerid);
          const selectedGarmentDesc = garmentsData.find((ste) => ste.Garment_Id === GarmentDescription);
          const selectedLine = lineData.find((obj) => obj.Line_id === Batchid);
          const selectedUnit = unitData.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
          console.log(selectedUnit, 'fgfg');
          GetAllActiveLineMstData(selectedUnit.Unit_Id)
          setbuyerSelected(selectedBuyer);
          setGarmentSelected(selectedGarmentDesc);
          setStyleDesc(StyleDescription);
          setStyleNum(StyleNumber);
          setLineSelected(selectedLine);
          setUnitSelected(selectedUnit);
          setRemarks(remarks);
          setSelectedImageFile(`${axios.baseURL}SrhImage/${SrhImage}`);
          setImagePreview(`${axios.baseURL}SrhImage/${SrhImage}`);
        });
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      } finally {
        setOpenLoader(false);
      }
    };
    const fetchAndSetOperations = async (id) => {
      try {
        const response = await axios.instance.get(`GetoneStyleRateDetail/${id}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        if (response.data && response.data.length > 0) {
          const receivedData = response.data;

          // Map received data to the desired format
          const newAddedOperations = receivedData.map((operation) => {
            // return {
            //   Operationid: operation.Operationid,
            //   OperationName: operation.OperationName,
            //   OperationGroup: operation.op_group_name,
            //   noOFWS: operation.emp_role,
            //   Machineid: operation.Mctype,
            //   RatePcsMale: operation.operation.RateOnMale,
            //   RatePcsFeMale: operation.RateOnFeMale,
            //   SPI: operation.Stitch_per_Inch,
            //   RMP: operation.RMP,
            //   CreatedBy: sessionStorage.getItem('UserID'),
            // };
            return {
              Operationid: operation.Operationid,
              OperationName: operation.OperationName,
              OperationGroup: operation.op_group_name,
              Machineid: operation.Machineid,
              noOFWS: operation.noOFWS,
              TypeOfWS: operation.emp_role,
              RatePcsMale: operation.RatePcsMale === null ? 0 : operation.RatePcsMale,
              RatePcsFeMale: operation.RatePcsFeMale === null ? 0 : operation.RatePcsFeMale,
              SPI: operation.Stitch_per_Inch,
              RMP: operation.RMP,
              CreatedBy: sessionStorage.getItem('UserID'),
              Srsno: operation.Srsno,
              finalOperation: operation.finalOperation,
            };
          });

          setOperationDetails(newAddedOperations);
          const selectedFinalOperation = newAddedOperations.find((operation) => operation.finalOperation === 'Y');
          setFinalOperation(selectedFinalOperation);
        }
      } catch (error) {
        console.error('Error fetching operations data:', error);
      }
    };

    if (id) {
      GetoneObHeader(id);
      fetchAndSetOperations(id);
    }
  }, [id, BuyerData, garmentsData]);

  // Updated form validation functions
  const validateOpeartinRequirements = () => {
    const errors = {
      buyerSelected: !buyerSelected,
      garmentSelected: !garmentSelected,
      styleDesc: !styleDesc,
      styleNum: !styleNum,
      // lineSelected: !lineSelected,
      // remarks: !remarks,
      unitSelected: !unitSelected,
      finalOperation: finalOperation === '',
      // selectedImageFile: !selectedImageFile,
    };
    setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, ...errors }));
    return !Object.values(errors).some(Boolean);
  };

  const handleFormSubmit = () => {
    if (type === 'review' || type === 'Rollback') {
      if (type === 'Rollback') {
        setOpenDelete(true);
      } else if (type === 'review') {
        ApproveSyleCard();
      }
    } else {
      if (!validateOpeartinRequirements()) {
        return;
      }

      let modifiedUrl;
      const originalUrl = selectedImageFile;
      const baseUrl = `${axios.baseURL}SrhImage/`;
      if (typeof originalUrl !== 'object') {
        modifiedUrl = originalUrl.replace(baseUrl, '');
      } else {
        modifiedUrl = selectedImageFile;
      }

      const formData = new FormData();
      // formData.append('ObDate', currentDate);
      // formData.append('ObNo', 1);
      // formData.append('Buyerid', buyerSelected.Buyer_Id);
      // formData.append('Unit_Id', unitSelected.Unit_Id);
      // formData.append('StyleDescription', styleDesc);
      // formData.append('StyleNumber', styleNum);
      // formData.append('GarmentDescription', garmentSelected.Garment_Id);
      // formData.append('Batchid', lineSelected.Line_id);
      // formData.append('remarks', remarks);
      // formData.append('SRCImage', modifiedUrl);
      // .input('Buyerid', sql.BigInt, SrhData.Buyerid)
      formData.append('Buyerid', buyerSelected.Buyer_Id);
      formData.append('StyleDescription', styleDesc);
      formData.append('StyleNumber', styleNum);
      formData.append('GarmentDescription', garmentSelected.Garment_Id);
      // formData.append('Batchid', lineSelected.Line_id);
      formData.append('Batchid', 0);
      formData.append('Remarks', remarks);
      formData.append('SrhImage', modifiedUrl);
      formData.append(
        'TotalcostMale',
        operationDetails.reduce((accumulator, currentObject) => {
          return Number(accumulator) + Number(currentObject.RatePcsMale);
        }, 0)
      );
      formData.append(
        'TotalcostFeMale',
        operationDetails.reduce((accumulator, currentObject) => {
          return Number(accumulator) + Number(currentObject.RatePcsFeMale);
        }, 0)
      );
      formData.append(
        'Totalcost',
        operationDetails.reduce((accumulator, currentObject) => {
          return Number(accumulator) + Number(currentObject.RatePcsMale);
        }, 0)
      );
      formData.append('Unitid', unitSelected.Unit_Id);
      formData.append('CreatedBy', sessionStorage.getItem('UserID'));
      formData.append('CompanyId', sessionStorage.getItem('CompanyId'));
      formData.append('FiscalYear', sessionStorage.getItem('FiscalYear'));

      if (operationDetails.filter((data) => data.noOFWS === 0).length === 0) {
        if (!id) {
          addNewOB(formData);
        } else {
          updateOB(id, formData);
        }
      } else {
        alert('Please enter NO of Machine');
      }
    }
  };

  const ApproveSyleCard = async () => {
    await axios.instance
      .put(
        `/ApproveStyleRate/${id}`,
        {
          ApproveBy: sessionStorage.getItem('UserID'),
          Type: type === 'review' ? 'Approve' : 'RollBack',
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        if (type === 'review') {
          setAlertType('success');
          setAlertMessage('SRC Approved Successfully');
          setopenAlert(true);
        } else {
          setAlertType('success');
          setAlertMessage('SRC RollBacked Successfully');
          setopenAlert(true);
        }

        setTimeout(() => {
          setopenAlert(false);
          setOpenLoader(false);
          navigate('/dashboard/manage/style_rate_card_approve/manage');
        }, 2000);
      });
  };

  const addNewOB = (newData) => {
    setOpenLoader(true);

    return axios.instance
      .post('/InsertStyleRateHearder', newData, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].Srhid !== undefined) {
          const Obheaderid = headerRes.data[0].Srhid;
          console.log(operationDetails);
          const detailPromises = operationDetails.map((obj, index) => {
            const insertData = {
              ...obj,
              srheaderid: Obheaderid,
              Srsno: index + 1,
            };

            return axios.instance.post('/InsertStyleRateDetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Added Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/style_rate_card');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error adding detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to add detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed')); // Ensure a consistent return value
      })
      .catch((error) => {
        // Handle error during header insertion
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error); // Ensure a consistent return value
      });
  };

  // put Request to edit record

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const updateOB = async (id, newData) => {
    setOpenLoader(true);

    return axios.instance
      .put(`/UpdateStyleRateHearder/${id}`, newData, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].Srhid !== undefined) {
          const Obheaderid = id;
          console.log(operationDetails, 'operationDetails');
          const detailPromises = operationDetails.map((obj) => {
            const insertData = {
              ...obj,
              srheaderid: Obheaderid,
            };

            console.log('InsertObDetail obj', insertData);

            return axios.instance.post('/InsertStyleRateDetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Updated Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/style_rate_card');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error updating detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to Updated detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed'));
      })
      .catch((error) => {
        // Handle error during header insertion
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  const handleInputChangeMachineSelect = (index, newValue) => {
    console.log(newValue);

    handleDetailChange(index, 'Machineid', newValue ? newValue.Machine_Id : null);
  };

  // const handleCheckboxChange = (operationId) => {
  //   setSelectedOperations((prevState) =>
  //     prevState.includes(operationId) ? prevState.filter((id) => id !== operationId) : [...prevState, operationId]
  //   );
  // };

  const handleCheckboxChange = (operationId) => {
    setSelectedOperations((prevState) => {
      if (prevState.includes(operationId)) {
        console.log(prevState, 'prevState');
        return prevState.filter((id) => id !== operationId);
      }
      console.log(operationId, 'operationId');
      return [...prevState, operationId];
    });
  };

  // const filteredOperations =
  //   opGroupSelected.op_group_name === 'All Groups'
  //     ? OperationData
  //     : OperationData.filter((obj) => obj.op_group_name === opGroupSelected.op_group_name);

  const handleAddOperations = () => {
    //  const newAddedOperations = OperationData.filter((operation) => selectedOperations.includes(operation.OperationId));
    const newAddedOperations = selectedOperations.map((operationId) =>
      OperationData.find((operation) => operation.OperationId === operationId)
    );
    const newOperationDetails = newAddedOperations.map((operation) => {
      const selectedMachineObj = machineData.find((obj) => obj.Machine_Id === operation.Machine_Id);

      console.log(operation);
      return {
        Operationid: operation.OperationId,
        OperationName: operation.OperationName,
        OperationGroup: operation.op_group_name,
        Machineid: selectedMachineObj ? selectedMachineObj.Machine_Id : null,
        // noOFWS: operation.emp_role,
        TypeOfWS: operation.emp_role,
        noOFWS: 0,
        RatePcsMale: operation.RateOnMale === null ? 0 : operation.RateOnMale,
        RatePcsFeMale: operation.RateOnFeMale === null ? 0 : operation.RateOnFeMale,
        SPI: selectedMachineObj.Stitch_per_Inch,
        RMP: selectedMachineObj.RMP,
        CreatedBy: sessionStorage.getItem('UserID'),
        finalOperation: 'N',
      };
    });
    // TO Select the operation in order
    const orderedOperationDetails = newOperationDetails.sort((a, b) => {
      return selectedOperations.indexOf(a.Operationid) - selectedOperations.indexOf(b.Operationid);
    });

    setOperationDetails((prevState) => [...prevState, ...orderedOperationDetails]);
    setSelectedOperations([]);
    setDialogOpen(false);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setOpGroupSelected({ op_group_name: 'All Groups' });
  };

  function handleDetailChange(index, field, value) {
    console.log(typeof value, 'dtl');
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Number(value);
    setOperationDetails(updatedDetails);
  }

  const handleDeleteOperation = (index) => {
    setOperationDetails((prevDetails) => prevDetails.filter((_, i) => i !== index));
  };

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
        >
          <Box>
            <Link
              to={
                type === 'review'
                  ? '/dashboard/manage/style_rate_card_approve/manage'
                  : '/dashboard/manage/style_rate_card'
              }
            >
              <Button variant="outlined" color="info" startIcon={<KeyboardBackspaceIcon />}>
                Back
              </Button>
            </Link>
          </Box>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={1}
            pl={2}
            color="white"
            sx={{
              borderTopLeftRadius: 50,
              borderBottomLeftRadius: 50,
              background: 'linear-gradient(to right, #67b26f, #4ca2cd)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2}>
              <KeyboardDoubleArrowLeftIcon />
              <Typography variant="h6" color="white" className="font_style1">
                Style Rate Card
              </Typography>
            </Stack>
          </Typography>
        </Stack>

        <Box sx={{ width: '100%' }}>
          <form onSubmit={handleFormSubmit} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', pb: 2 }}>
              {id1 === '1' && (
                <Button variant="outlined" fullWidth color="error" my={2} sx={{ textTransform: 'uppercase', mt: 2 }}>
                  View-only. No changes allowed
                </Button>
              )}
              <Divider sx={{ mb: 1, mt: 2 }}>
                <Chip label="Operational Requirements" size="small" color="success" />
              </Divider>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                spacing={2}
                mb={2}
              >
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  spacing={2}
                >
                  <Box>
                    {id && (
                      <Typography variant="h6" color="#1679AB">
                        SRC Number : {headerData.SrhNo}
                      </Typography>
                    )}
                  </Box>
                </Stack>
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  spacing={2}
                >
                  <Box>
                    <Typography variant="h6" color="#1679AB">
                      Date : <span>{formatDate(currentDate)}</span>
                    </Typography>
                  </Box>
                </Stack>
              </Stack>
              {type === 'review' ? (
                <>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12} md={9}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                        <Grid item md={4} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Buyer
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.Buyer_Name}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Garments Description
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.Garment_Description}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Style Description
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.StyleDescription}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Style Number
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.StyleNumber}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Production Unit
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.Unit_Name}
                            </Typography>
                          </Stack>
                        </Grid>
                        {/* <Grid item md={4} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Batch or Line
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.Line_Name}
                            </Typography>
                          </Stack>
                        </Grid> */}
                        <Grid item md={12} xs={12}>
                          <Stack justifyContent={'flex-start'} direction={'column'}>
                            <Typography variant="h6" color="GrayText" pr={1}>
                              Remarks
                            </Typography>
                            <Typography variant="h6" color="#009688">
                              {headerData.remarks}
                            </Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        border={1}
                        borderRadius={1}
                        borderColor="#e0e0e0"
                        p={1}
                        justifyContent="center"
                        sx={{ width: '100%' }}
                      >
                        <img
                          src={
                            imagePreview === `${axios.baseURL}OperationBulletin/` ||
                              imagePreview === null ||
                              imagePreview === ''
                              ? noImage
                              : imagePreview
                          }
                          // src={imagePreview === null || imagePreview === '' ? noImage : imagePreview}
                          alt="imgfor"
                          className={classes.chooseFileButton}
                          style={{ maxWidth: '200px', maxHeight: '189px', objectFit: 'contain' }}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item md={9}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                        <Grid item md={4} xs={12}>
                          <FormControl size="small" fullWidth component="fieldset" required>
                            <Autocomplete
                              size="small"
                              fullWidth
                              options={BuyerData}
                              getOptionLabel={(obj) => (obj ? obj.Buyer_Name : '')}
                              isOptionEqualToValue={
                                ((option, value) => option?.Buyer_Id === value?.Buyer_Id) ?? undefined
                              }
                              disabled={id1 === '1'}
                              renderInput={(params) => <TextField {...params} label="Buyer" required />}
                              value={buyerSelected}
                              onChange={(e, newValue) => {
                                setbuyerSelected(newValue);
                                setFieldErrors((prevFieldErrors) => ({
                                  ...prevFieldErrors,
                                  buyerSelected: !newValue,
                                }));
                              }}
                            />
                            {fieldErrors.buyerSelected && (
                              <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                                Please select buyer
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <FormControl size="small" fullWidth component="fieldset" required>
                            <Autocomplete
                              size="small"
                              fullWidth
                              options={garmentsData}
                              disabled={id1 === '1'}
                              getOptionLabel={(deg) => (deg ? deg.Garment_Description : '')}
                              isOptionEqualToValue={
                                ((option, value) => option?.Garment_Id === value?.Garment_Id) ?? undefined
                              }
                              renderInput={(params) => <TextField {...params} label="Garments Description" required />}
                              value={garmentSelected}
                              onChange={(e, newValue) => {
                                setGarmentSelected(newValue);
                                setFieldErrors((prevFieldErrors) => ({
                                  ...prevFieldErrors,
                                  garmentSelected: !newValue,
                                }));
                              }}
                            />
                            {fieldErrors.garmentSelected && (
                              <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                                Please select your garment description
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            size="small"
                            fullWidth
                            disabled={id1 === '1'}
                            required
                            label="Style Description"
                            value={styleDesc}
                            onChange={(e) => {
                              setStyleDesc(e.target.value);
                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                styleDesc: !e.target.value,
                              }));
                            }}
                            error={fieldErrors.styleDesc}
                            helperText={fieldErrors.styleDesc && 'enter style description'}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            size="small"
                            fullWidth
                            disabled={id1 === '1'}
                            required
                            label="Style Number"
                            value={styleNum}
                            onChange={(e) => {
                              setStyleNum(e.target.value);
                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                styleNum: !e.target.value,
                              }));
                            }}
                            error={fieldErrors.styleNum}
                            helperText={fieldErrors.styleNum && 'enter style number'}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl size="small" fullWidth component="fieldset" required>
                            <Autocomplete
                              size="small"
                              fullWidth
                              disabled={id1 === '1'}
                              options={unitData}
                              getOptionLabel={(obj) => (obj ? obj.Unit_Name : '')}
                              isOptionEqualToValue={
                                ((option, value) => option?.Unit_Id === value?.Unit_Id) ?? undefined
                              }
                              renderInput={(params) => <TextField {...params} label="Production Unit" required />}
                              value={unitSelected}
                              onChange={(e, newValue) => {
                                setUnitSelected(newValue);
                                setFieldErrors((prevFieldErrors) => ({
                                  ...prevFieldErrors,
                                  unitSelected: !newValue,
                                }));
                              }}
                            />
                            {fieldErrors.unitSelected && (
                              <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                                Please select production unit
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        {/* <Grid item xs={12} md={4}>
                          <FormControl size="small" fullWidth component="fieldset" required>
                            <Autocomplete
                              size="small"
                              fullWidth
                              disabled={id1 === '1'}
                              options={lineData}
                              getOptionLabel={(obj) => (obj ? obj.Line_Name : '')}
                              isOptionEqualToValue={
                                ((option, value) => option?.Line_id === value?.Line_id) ?? undefined
                              }
                              renderInput={(params) => <TextField {...params} label="Batch or Line" required />}
                              value={lineSelected}
                              onChange={(e, newValue) => {
                                setLineSelected(newValue);
                                setFieldErrors((prevFieldErrors) => ({
                                  ...prevFieldErrors,
                                  lineSelected: !newValue,
                                }));
                              }}
                            />
                            {fieldErrors.lineSelected && (
                              <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                                Please select batch or line
                              </Typography>
                            )}
                          </FormControl>
                        </Grid> */}
                        <Grid item xs={12} md={12}>
                          <TextField
                            size="small"
                            fullWidth
                            label="Remarks"
                            multiline
                            rows={3}
                            disabled={id1 === '1'}
                            value={remarks}
                            type="number"
                            onChange={(e) => {
                              setRemarks(e.target.value);
                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                remarks: !e.target.value,
                              }));
                            }}
                            error={fieldErrors.remarks}
                            helperText={fieldErrors.remarks && 'enter remarks'}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        border={1}
                        borderRadius={1}
                        borderColor="#e0e0e0"
                        p={1}
                        sx={{ width: '100%' }}
                        justifyContent="center"
                      >
                        <label htmlFor="fileInput">
                          <img
                            src={
                              selectedImageFile === `${axios.baseURL}SrhImage/`
                                ? noImage
                                : selectedImageFile === null || selectedImageFile === '' || !selectedImageFile
                                  ? imagepreview
                                  : imagePreview
                            }
                            // src={!selectedImageFile ? imagepreview : imagePreview}
                            alt="imgfor"
                            className={classes.chooseFileButton}
                            style={{ maxWidth: '200px', maxHeight: '180px', objectFit: 'contain' }}
                          />
                          <input
                            className={classes.fileInput}
                            id="fileInput"
                            type="file"
                            onChange={(event) => {
                              handleFileChange(event, 'photo');
                            }}
                            style={{ display: 'none' }}
                          />
                        </label>
                      </Stack>
                      {fieldErrors.selectedFilePan && (
                        <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                          Please attach the photo
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </form>
        </Box>

        <Divider sx={{ mb: 1 }}>
          <Chip label="Operations" size="small" color="success" />
        </Divider>

        <Stack justifyContent={'center'} alignItems={'end'} spacing={2} fullWidth mb={2}>
          <Button variant="outlined" color="inherit" disabled={type === 'review'} onClick={handleDialogOpen}>
            Add Operations
          </Button>
        </Stack>
        <Stack justifyContent={'space-between'} alignItems={'center'} direction={'row'} spacing={2} fullWidth mb={2}>
          <FormControl size="small" sx={{ minWidth: '300px' }} component="fieldset" required>
            <Autocomplete
              size="small"
              fullWidth
              options={operationDetails}
              getOptionLabel={(obj) => (obj ? obj.OperationName : '')}
              isOptionEqualToValue={((option, value) => option?.Operationid === value?.Operationid) ?? undefined}
              renderInput={(params) => <TextField {...params} label="Final Operation" required />}
              value={finalOperation}
              onChange={(e, newValue) => {
                if (newValue) {
                  setFinalOperation(newValue);
                  setOperationDetails((prevState) =>
                    prevState.map((operation) =>
                      operation.Operationid === newValue.Operationid
                        ? { ...operation, finalOperation: 'Y' }
                        : { ...operation, finalOperation: 'N' }
                    )
                  );
                  setFieldErrors((prevFieldErrors) => ({
                    ...prevFieldErrors,
                    finalOperation: !newValue,
                  }));
                } else {
                  setFinalOperation({OperationName:'',Operationid:0})
                }
              }}

            // onChange={(e, newValue) => {
            //   setFinalOperation(newValue);
            //   setFieldErrors((prevFieldErrors) => ({
            //     ...prevFieldErrors,
            //     finalOperation: !newValue,
            //   }));
            // }}
            />
            {fieldErrors.finalOperation && (
              <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                Please select final operation
              </Typography>
            )}
          </FormControl>
        </Stack>

        {operationDetails.length > 0 && (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <StyledTableHeader align="center" colSpan={7}>
                    {''}
                  </StyledTableHeader>
                  <StyledTableHeader align="center" colSpan={2}>
                    Rate/Pieces
                  </StyledTableHeader>
                  <StyledTableHeader align="center" colSpan={1}>
                    {' '}
                  </StyledTableHeader>
                </TableRow>
                <TableRow>
                  <StyledTableHeader align="center">S.No</StyledTableHeader>
                  <StyledTableHeader align="left">Operation</StyledTableHeader>
                  <StyledTableHeader align="left">Group </StyledTableHeader>
                  <StyledTableHeader align="left">Type of W/S</StyledTableHeader>
                  <StyledTableHeader align="left">No of W/S</StyledTableHeader>
                  <StyledTableHeader colSpan={2} align="center">
                    M/C Type
                  </StyledTableHeader>
                  <StyledTableHeader align="center">Male</StyledTableHeader>
                  <StyledTableHeader align="center">Female</StyledTableHeader>
                  <StyledTableHeader align="center">Actions</StyledTableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {operationDetails.map((obj, index) => (
                  <TableRow
                    key={index}
                    hover
                    sx={{
                      backgroundColor: obj.finalOperation === 'Y' ? '#D6EFD8' : 'inherit',
                    }}
                  >
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                      {obj.OperationName}
                    </TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                      {obj.OperationGroup}
                    </TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                      {obj.TypeOfWS === 'O' ? 'Operator' : 'Helper'}
                    </TableCell>
                    <TableCell style={{ minWidth: '100px' }}>
                      <TextField
                        id={`noOFWS${index}`}
                        disabled={id1 === '1'}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        size="small"
                        fullWidth
                        type="number"
                        value={operationDetails[index].noOFWS}
                        onChange={(e) => {
                          handleDetailChange(index, 'noOFWS', e.target.value);
                        }}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                            document.getElementById(`noOFWS${index + 1}`).focus();
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell colSpan={2} style={{ minWidth: '250px' }}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        disabled={type === 'review' || id1 === '1'}
                        name="group"
                        options={machineData}
                        getOptionLabel={(obj) => (obj ? obj.MachineType : '')}
                        value={
                          machineData.find(
                            (machine) => Number(machine.Machine_Id) === Number(operationDetails[index].Machineid)
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          handleInputChangeMachineSelect(index, newValue);
                          console.log(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} label="" />}
                      />
                    </TableCell>

                    <TableCell style={{ minWidth: '100px' }}>
                      <TextField
                        id={`Male${index}`}
                        disabled={id1 === '1'}
                        size="small"
                        fullWidth
                        type="number"
                        value={operationDetails[index].RatePcsMale}
                        onChange={(e) => {
                          handleDetailChange(index, 'RatePcsMale', e.target.value);
                        }}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                            document.getElementById(`Male${index + 1}`).focus();
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell style={{ minWidth: '100px' }}>
                      <TextField
                        disabled={id1 === '1'}
                        id={`Female${index}`}
                        size="small"
                        fullWidth
                        type="number"
                        value={operationDetails[index].RatePcsFeMale}
                        onChange={(e) => {
                          handleDetailChange(index, 'RatePcsFeMale', e.target.value);
                        }}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                            document.getElementById(`Female${index + 1}`).focus();
                          }
                        }}
                      />
                    </TableCell>

                    <TableCell align="center" sx={{ padding: '0' }}>
                      <IconButton
                        aria-label="Delete"
                        disabled={type === 'review' || id1 === '1'}
                        onClick={() => handleDeleteOperation(index)}
                      >
                        <DeleteForeverIcon color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Divider sx={{ my: 2 }}>
          <Chip label="Summary" size="small" color="success" />
        </Divider>

        <Grid
          container
          justifyContent={'center'}
          alignItems={'center'}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          pt={1}
        >
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Total Cost
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.RatePcsMale);
                    }, 0)
                    .toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Key Hole
                </Typography>
              </Grid>
              <Grid item md={8}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {'0.00'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item md={2}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Button
                </Typography>
              </Grid>
              <Grid item md={10}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {'0'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Feeding Helper
                </Typography>
              </Grid>
              <Grid item md={8}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {'00'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Final Cost/Pcs
                </Typography>
              </Grid>
              <Grid item md={8}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {'00'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            {' '}
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', pt: 2 }}>
          {type === 'review' ? (
            <Button onClick={handleFormSubmit} color="success" endIcon={<CheckCircleIcon />} variant="outlined">
              Approve
            </Button>
          ) : type === 'Rollback' ? (
            <Button onClick={handleFormSubmit} color="error" endIcon={<CheckCircleIcon />} variant="outlined">
              Rollback
            </Button>
          ) : (
            <Button
              onClick={handleFormSubmit}
              disabled={id1 === '1'}
              color="success"
              endIcon={<CheckCircleIcon />}
              variant="contained"
            >
              Submit
            </Button>
          )}
        </Box>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* add oprations */}
      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Select Operations</DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ op_group_name: 'All Groups' }, ...opGroupData]}
                getOptionLabel={(obj) => (obj ? obj.op_group_name : '')}
                isOptionEqualToValue={(option, value) => option?.OP_group_id === value?.OP_group_id}
                renderInput={(params) => <TextField {...params} label="Operation Group" />}
                value={opGroupSelected}
                onChange={(e, newValue) => {
                  setOpGroupSelected(newValue);
                  setFieldErrors((prevFieldErrors) => ({
                    ...prevFieldErrors,
                    setOpGroupSelected: !newValue,
                  }));
                }}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  <TableCell>Operation</TableCell>
                  <TableCell>Group</TableCell>
                  <TableCell>Machine</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.OperationName}</TableCell>
                    <TableCell align="left">{obj.op_group_name}</TableCell>
                    <TableCell align="left">{obj.Machine_name}</TableCell>
                    <TableCell align="left">{obj.emp_role === 'O' ? 'Operator' : 'Helper'}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Checkbox
                        checked={selectedOperations.includes(obj.OperationId)}
                        onChange={() => handleCheckboxChange(obj.OperationId)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          {selectedOperations.length > 0 && (
            <Button onClick={handleAddOperations} color="primary">
              Add Selected
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Grid m={2}>
        {/* delete confirmation popup dialog box */}
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen={fullScreen}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">{'Are you sure want to cancel the approval ?'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={() => ApproveSyleCard()} color="error" autoFocus>
              Yes , RollBack
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
